import Modal from '../modules/Modal';
import IncreaseLiquidity, {
  IncreaseLiquidityProps,
} from '../views/IncreaseLiquidity';

const IncreaseLiquidityModal = (props: IncreaseLiquidityProps) => {
  return (
    <Modal size="3xl" clickOffToClose>
      <div className="py-4 px-6 bg-gray-50">
        <IncreaseLiquidity {...props} withinModal={true} />
      </div>
    </Modal>
  );
};

export default IncreaseLiquidityModal;
